export default __webpack_public_path__ + "static/media/star.f4cec764.svg";